import { Injectable } from '@angular/core'
import { RoutingService } from "@spartacus/core";
import { OrderHistoryService } from "@spartacus/order/core";
import { TableService, TableStructure } from '@spartacus/storefront'
import {combineLatest, Observable, of, Subject} from 'rxjs'
import {distinctUntilChanged, map, shareReplay, switchMap, tap} from "rxjs/operators";
import { DEFAULT_TABLE_STRUCTURE } from '../../../../components/table/eb-table.interface'
import { EbLanguageService } from "../../../site-context/services/eb-language.service";
import { EbOrder, SalesDocumentList } from '../../interfaces/eb-order.interface'
import { EbOrderAdapter } from '../connectors/eb-order.adapter'

@Injectable({
    providedIn: 'root'
})
export class EbOrderHistoryService{
  static readonly orderHistoryLoaded$: Subject<void> = new Subject<void>();
  orderCode$: Observable<string>;
  orderLoad$: Observable<{}>;


  constructor(
      protected routingService: RoutingService,
      protected tableService: TableService,
      protected languageService: EbLanguageService,
      protected orderAdapter: EbOrderAdapter,
      protected orderHistoryService: OrderHistoryService
      ) {

    this.orderCode$ = this.routingService.getRouterState().pipe(
        map(routingData => {
          if (routingData.state.params.orderCode) {
            return routingData.state.params.orderCode
          } else {
            return routingData.state.url.split('/').pop()
          }
        }),
        distinctUntilChanged()
    )

    this.orderLoad$ = combineLatest([this.languageService.getActive(), this.orderCode$]).pipe(
        tap(([, orderCode]) => {
          if (orderCode) {
              orderHistoryService.loadOrderDetails(orderCode)
          } else {
              orderHistoryService.clearOrderDetails()
          }
        }),
        shareReplay({ bufferSize: 1, refCount: true })
    )

  }

 getOrderDetails(): Observable<EbOrder> {
    return combineLatest([this.languageService.getActive(), this.orderLoad$]).pipe(
        switchMap(() => this.orderHistoryService.getOrderDetails()),
        switchMap(order=> {return of(order as EbOrder)})
    )
  }

  getOrderHistoryTableStructure(): Observable<TableStructure> {
    return this.tableService.buildStructure('orderHistory', DEFAULT_TABLE_STRUCTURE)
  }

  getOrderHistoryDocumentsTableStructure(): Observable<TableStructure> {
    return this.tableService.buildStructure('orderHistoryDocuments', DEFAULT_TABLE_STRUCTURE)
  }

  getOrders(currentPage: number, pageSize: number): Observable<SalesDocumentList> {
    return this.orderAdapter.getOrdersForCurrentUser(currentPage, pageSize)
  }

  orderHistoryPageLoaded(): void {
    EbOrderHistoryService.orderHistoryLoaded$.next()
  }

  getOrderHistoryLoadedObservable(): Observable<void> {
    return EbOrderHistoryService.orderHistoryLoaded$.asObservable();
  }
}
